import "../../../FhRadioGroup.css";
import { toRef, watch, provide, reactive, openBlock, createElementBlock, renderSlot, createElementVNode, unref, createBlock, withCtx, createTextVNode, toDisplayString, createCommentVNode } from "vue";
import useIsFieldRequired from "../composables/useIsFieldRequired.mjs";
import useFormField from "../composables/useFormField.mjs";
import { InputFieldContextKey } from "../Symbols.mjs";
import { generateUniqueId } from "../../utils.mjs";
import FhValidationMessage from "../FhValidationMessage/FhValidationMessage.mjs";
import { _ as _export_sfc } from "../../../_plugin-vue_export-helper-1tPrXgE0.js";
const _hoisted_1 = ["disabled"];
const _hoisted_2 = { class: "fh-radio-list" };
const _sfc_main = {
  __name: "FhRadioGroup",
  props: {
    name: {
      type: String,
      default: ""
    },
    modelValue: {
      type: [String, Number, Boolean],
      default: ""
    },
    validators: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const props = __props;
    const {
      meta,
      value: groupValue,
      withinForm,
      setValue,
      errorMessage,
      handleChange: handleRadioChange,
      handleBlur
    } = useFormField(props.name, props.modelValue, {
      validators: toRef(props, "validators"),
      disabled: toRef(props, "disabled")
    });
    if (!withinForm) {
      watch(
        () => props.modelValue,
        (newValue) => {
          if (newValue !== groupValue) {
            setValue(newValue);
          }
        },
        { deep: true }
      );
    }
    const handleChange = (newValue) => {
      if (!withinForm) {
        emit("update:modelValue", newValue);
      }
      setValue(newValue);
      handleRadioChange(newValue);
      handleBlur();
    };
    const required = useIsFieldRequired();
    const uniqueId = generateUniqueId();
    const componentId = `fh-radio-group--${uniqueId}`;
    const validationId = `fh-validation--${uniqueId}`;
    provide(
      InputFieldContextKey,
      reactive({
        disabled: toRef(props, "disabled"),
        id: componentId
      })
    );
    provide("radioGroupContext", {
      name: props.name,
      groupValue,
      groupDisabled: toRef(props, "disabled"),
      meta,
      validationId,
      errorMessage,
      required,
      handleChange,
      handleBlur
    });
    return (_ctx, _cache) => {
      var _a;
      return openBlock(), createElementBlock("fieldset", {
        disabled: props.disabled
      }, [
        renderSlot(_ctx.$slots, "label", {}, void 0, true),
        createElementVNode("ul", _hoisted_2, [
          renderSlot(_ctx.$slots, "default", {}, void 0, true)
        ]),
        unref(errorMessage) && ((_a = unref(meta)) == null ? void 0 : _a.touched) ? (openBlock(), createBlock(FhValidationMessage, {
          key: 0,
          id: validationId
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(unref(errorMessage)), 1)
          ]),
          _: 1
        })) : createCommentVNode("", true)
      ], 8, _hoisted_1);
    };
  }
};
const FhRadioGroup = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-d625465b"]]);
export {
  FhRadioGroup as default
};
//# sourceMappingURL=FhRadioGroup.mjs.map
